import React from 'react';
import Button from '@material-ui/core/Button';
import FullScreenError from '../../external/components/FullScreenError/NotFoundError';
import { GlobalState } from '../../types/redux.types';
import styles from './page-not-found.module.scss';

export interface PageNotFoundProps extends GlobalState {}

export default function PageNotFound({ dark }: PageNotFoundProps) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <FullScreenError />
        <h1 className={styles.title} style={{ color: dark ? '#ffffff' : '#201f1e' }}>
          Page not found
        </h1>
        <Button
          variant='contained'
          color='secondary'
          className={styles.button}
          onClick={() => window.history.back()}
        >
          Go back
        </Button>
      </div>
    </div>
  );
}
